import CIMSTable from 'components/CIMSTable'
import { useDispositionTypesContext } from './DispositionTypesContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

const DispositionTypes: React.FC = () => {
  const {
    dispositionTypes,
    loading,
    refetch: onReload,
  } = useDispositionTypesContext()
  return (
    <CIMSTable
      records={dispositionTypes}
      rowKey="id"
      loading={loading}
      columns={useColumns()}
      actions={{
        header: { onReload, create: useCreate() },
        row: { edit: useEdit(), restore: useRestore(), remove: useRemove() },
      }}
      expand={useExpand()}
    />
  )
}

export default DispositionTypes
